import React from 'react';
import { Link } from 'react-router-dom';
import { useParallax } from 'react-scroll-parallax';

// Accent images
const EEL = 'https://santaplaya-bucket.s3.amazonaws.com/eel.webp';
const PRAWN_BORDER =
  'https://santaplaya-bucket.s3.amazonaws.com/prawn_border.webp';
const BLUE_BUBBLES =
  'https://santaplaya-bucket.s3.amazonaws.com/bubbles_blue.webp';
const SHELL = 'https://santaplaya-bucket.s3.amazonaws.com/Shell.webp';
const CHEF_TEXT = 'https://santaplaya-bucket.s3.amazonaws.com/ChefText.webp';

const AboutUsSection: React.FC = () => {
  // Parallax hooks
  // 1) Eel drifting side-to-side
  const eelRef = useParallax<HTMLDivElement>({
    translateX: [0, -120],
    easing: 'easeInOut',
  });

  // 2) Bubbles #1 rising
  const bubblesTopRef = useParallax<HTMLDivElement>({
    translateY: [20, -20],
    easing: 'easeInOut',
  });

  // 3) Bubbles #2 rising
  const bubblesBottomRef = useParallax<HTMLDivElement>({
    translateY: [15, -15],
    easing: 'easeInOut',
  });

  // 4) Shell rotating gently (or drifting). Example: rotate
  const shellRef = useParallax<HTMLDivElement>({
    rotate: [-20, 20],
    easing: 'easeInOut',
  });

  return (
    <section className="relative w-full bg-white overflow-visible">
      {/* EEL (top-left) */}
      <div
        ref={eelRef.ref}
        className="
          pointer-events-none
          absolute
          top-1/4
          left-[10%]
          w-[20vw]
          z-0
          opacity-90
        "
      >
        <img src={EEL} alt="Eel Accent" className="w-full h-auto" />
      </div>

      {/* 1st BUBBLES (top-right) */}
      <div
        ref={bubblesTopRef.ref}
        className="
          pointer-events-none
          absolute
          top-2/3
          left-[5%]
          w-[8vw]
          z-0
          opacity-80
        "
      >
        <img
          src={BLUE_BUBBLES}
          alt="Bubbles Accent Top Right"
          className="w-full h-auto"
        />
      </div>

      {/* 2nd BUBBLES (bottom-left) */}
      <div
        ref={bubblesBottomRef.ref}
        className="
          pointer-events-none
          absolute
          top-[5%]
          right-[15%]
          w-[6vw]
          z-0
          opacity-80
        "
      >
        <img
          src={BLUE_BUBBLES}
          alt="Bubbles Accent Bottom Left"
          className="w-full h-auto"
        />
      </div>

      {/* SHELL (bottom-right) */}
      <div
        ref={shellRef.ref}
        className="
          pointer-events-none
          absolute
          bottom-[45%]
          right-[10%]
          w-[8vw]
          z-0
          opacity-80
        "
      >
        <img src={SHELL} alt="Shell Accent" className="w-full h-auto" />
      </div>

      {/* ~~~ MAIN CONTENT ~~~ */}
      <div
        className="
          relative z-10
          max-w-4xl
          mx-auto
          flex flex-col
          items-center
          text-center
          py-12
          px-4
          sm:px-8
          md:px-12
        "
      >
        {/* Title: About Us */}
        <h2 className="font-charles text-maroon text-4xl sm:text-5xl md:text-6xl mb-4">
          About Us
        </h2>

        {/* Lines in Prosto + sea color */}
        <p className="font-prosto text-sea text-2xl sm:text-3xl md:text-4xl mb-2">
          FROM HUMBLE BEGINNINGS
        </p>
        <br />
        <p className="font-prosto text-sea text-2xl sm:text-3xl md:text-4xl mb-2">
          TO CULINARY SUCCESS,
        </p>
        <div className="flex justify-center my-6">
          <img
            src={CHEF_TEXT}
            alt="Discover How Chef Yona Brings"
            className="
              w-full
              max-w-4xl
              h-auto
              object-cover
            "
          />
        </div>
        <p className="font-prosto text-sea text-2xl sm:text-3xl md:text-4xl mb-6 mt-4">
          THE ESSENCE OF BAJA TO YOUR TABLE.
        </p>

        {/* Button: Discover Our Story */}
        <Link
          to="/about-us"
          className="
            bg-sea
            text-white
            font-prosto
            rounded-full
            py-4 px-8
            text-sm
            sm:text-sm
            hover:bg-sea/90
            transition-all
            mt-12
          "
        >
          Discover Our Story
        </Link>
      </div>

      {/* PRAWN BORDER (normal flow) */}
      <div className="flex justify-center mb-8 mt-24">
        <img
          src={PRAWN_BORDER}
          alt="Prawn Border"
          className="w-full max-w-4xl h-auto object-cover"
        />
      </div>
    </section>
  );
};

export default AboutUsSection;
